import Footer from '../../../components/Footer';
import NavBar from '../../../components/NavBar';
import useAuth from '../../../hooks/useAuth';
import { listarBooksPorAluno } from '../../../services/api';
import { Badge, Button, Flex, Skeleton, Stack, Text, useToast} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { BookGet } from '../../Books';
import { useNavigate } from 'react-router-dom';
import { BsFileEarmarkMedicalFill } from 'react-icons/bs';
import { abrirMaterialDoBook } from '../../../utils/materialWindow';

export default function PortalMateriais() {
	const { functionId } = useAuth();
	const [loading, setLoading] = useState(true);
	const [ books, setBooks ] = useState<BookGet[]>([]);
    const toast = useToast();
    const navigate = useNavigate();

	// functionId vem do AuthContext (resolvido no login). So carregamos os books
	// do aluno; a antiga busca de aulas aqui era redundante e nunca era exibida.
	useEffect(() => {
		if (!functionId) return;
		setLoading(true);
		listarBooksPorAluno(functionId)
			.then((response) => {
				setBooks(response.data);
				setLoading(false);
			})
			.catch((err) => {
				toast({
					title: `Não foi possível carregar o livro${err}`,
					status: 'error',
					isClosable: true
				});
			});
	}, [ functionId, toast ]);
    
	return (
		<>
			<NavBar />
			<Flex 
                width={'100%'} 
                minH={"85vh"}  
                justifyContent="center" 
                bgColor="paper"
                overflowX="unset"
                padding="50px"
            >
                <Flex 
                    gap="10px" 
                    width="90%"
                    flexDir="column"
                    alignItems="center"
                >
                    <Text fontSize="32px" fontWeight="800">Materiais</Text>
                    <Flex gap="10px" flexWrap="wrap">

                        {
                            loading ? 
                            <Flex width={'90%'}>
                                <Stack>
                                    <Skeleton height='40px' />
                                    <Skeleton height='40px' />
                                    <Skeleton height='40px' />
                                </Stack>
                            </Flex>
                            :
                            books && books.map((book) => (
                                <Flex
                                    key={book.id}
                                    width="250px"
                                    height="255px"
                                    bgColor="blue.700"
                                    borderRadius="25px"
                                    alignItems="center"
                                    justifyContent="center"
                                    flexDir="column"
                                    gap="10px"
                                    borderWidth="3px"
                                    borderColor="white"
                                    boxShadow="lg"
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`Abrir o livro ${book.nome}`}
                                    _hover={{
                                        backgroundColor:"blue.800",
                                        cursor:"pointer"
                                    }}
                                    _focusVisible={{
                                        outline:"3px solid",
                                        outlineColor:"brass",
                                        outlineOffset:"2px"
                                    }}
                                    onClick={()=>{
                                        abrirMaterialDoBook(book.id)
                                    }}
                                    onKeyDown={(e)=>{
                                        if(e.key === 'Enter' || e.key === ' '){
                                            e.preventDefault();
                                            abrirMaterialDoBook(book.id);
                                        }
                                    }}
                                >
                                    <Flex
                                        height="130px"
                                        bgImage={book.capa}
                                        minWidth="230px"
                                        maxWidth="230px"
                                        bgPosition="center"
                                        bgSize="cover"
                                        borderRadius="10px"
                                    />
                                    <Flex alignItems="center" gap="10px" justifyContent="center">
                                        <Flex flexDir="column">
                                            <Text color="white" fontSize="20px" fontWeight="800" textAlign="center">
                                                {book.nome}
                                            </Text>
                                            <Flex gap="10px" justifyContent="center">
                                                <Badge>{book.idioma}</Badge>
                                                <Badge colorScheme="blue">{book.nivel}</Badge>
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                    <Button
                                        size="xs"
                                        variant="outline"
                                        color="white"
                                        borderColor="whiteAlpha.700"
                                        leftIcon={<BsFileEarmarkMedicalFill />}
                                        _hover={{ bgColor:"whiteAlpha.300" }}
                                        _active={{ bgColor:"whiteAlpha.400" }}
                                        onClick={(e)=>{
                                            // O card inteiro abre o material, entao o clique nas homeworks
                                            // nao pode subir e disparar o popup do PDF junto.
                                            e.stopPropagation();
                                            navigate(`/portal/books/${book.id}`);
                                        }}
                                    >
                                        Homeworks
                                    </Button>
                                </Flex>
                            ))
                        }
                    </Flex>
                </Flex>
			</Flex>
			<Footer />
		</>
	);
}
